var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDriplineConnectionPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DRIPLINE_CONNECTION_POINT",
    transform: "translate(.5 .5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_121",
    d: "M8 0a8 8 0 1 0 8 8 7.991 7.991 0 0 0-8-8z",
    fill: "#7826ff",
    stroke: "#3e4346"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_51",
    transform: "translate(3 3.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_122",
    d: "M15.45 8.4v1.5h-1.6v1.25h-.65V9.9H8.85v1.25H8.2V9.9H6.5V8.4h8.95m.5-.5H6v2.5h1.6v1.25h1.65V10.4h3.35v1.25h1.65V10.4h1.6V7.9z",
    fill: "#fff",
    transform: "translate(-6 -7.9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_123",
    d: "M20.9 19.65a1.4 1.4 0 0 1-2.8 0c0-.75 1.4-2.75 1.4-2.75s1.4 1.95 1.4 2.75zm-.75-.45a.35.35 0 1 0 .35.35.376.376 0 0 0-.35-.35z",
    fill: "#fff",
    transform: "translate(-9.05 -8.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_124",
    d: "M10.9 19.65a1.4 1.4 0 0 1-1.4 1.4 1.367 1.367 0 0 1-1.4-1.4c0-.75 1.4-2.75 1.4-2.75s1.4 1.95 1.4 2.75zm-.8-.45a.35.35 0 1 0 .35.35.342.342 0 0 0-.35-.35z",
    fill: "#fff",
    transform: "translate(-4.05 -8.45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriplineConnectionPoint);
export default __webpack_public_path__ + "static/media/dripline_connection_point.2097d6ccfa4504fc0843b696b7f655e5.svg";
export { ForwardRef as ReactComponent };